import styled from 'styled-components';

export const Copyright = styled.span``;

export const Footer = styled.div`
  display: flex;
  flex: 0 0 auto;
  justify-content: center;
  height: 30px;
  line-height: 30px;
  color: #FFF;
  background-color: #575858;
`;
